<template>
  <div>
    <ActitiveTabcomponent :tabs="tabItems" :defaultTab="activeTab" @tab-changed="handleTabChange">
      <template v-slot:tab-buttons="{ activeTab }">
        <div class="flex items-center space-x-2">
          <!-- Role tab actions -->
          <template v-if="activeTab === 'role'">
            <v-col
              :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
              :class="[$vuetify.breakpoint.lgAndUp ? 'py-0 pr-0 ' : 'ml-auto mt-2 p-0 ']"
            >
              <v-text-field
                outlined
                dense
                hide-details
                placeholder="Search Role"
                v-model="roleFilter"
                @input="handleRoleFilterInput"
                clearable
                class="filter-column"
              ></v-text-field>
            </v-col>
            <v-btn
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text"
              v-iam-disabled="'organization.roles.create'"
              @click="handleAddRole"
              dense
            >
              <v-icon left dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <!-- Employees tab actions -->
          <template v-if="activeTab === 'employees'">
            <v-btn @click="handleOrgTree" :color="$vuetify.theme.currentTheme.primary" outlined>
              <v-icon>{{ viewOrgTree ? 'mdi-table' : 'mdi-file-tree' }}</v-icon>
            </v-btn>
            <v-btn
              @click="handleAddEmployee"
              v-iam-disabled="'organization.employees.create'"
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
            <FilterPopOver :selectedCount="selectedCount">
              <v-card
                outlined
                class="w-72 max-h-96"
                :color="$vuetify.theme.currentTheme.navigationColor"
              >
                <v-list>
                  <v-list-item class="px-0">
                    <v-col class="pb-0">
                      <v-select
                        class="wfm-search-fields"
                        :items="roles"
                        hide-details
                        solo
                        flat
                        clearable
                        outlined
                        label="Select Role"
                        placeholder="Select Role"
                        v-model="selectedRoleFilter"
                        item-text="role"
                        item-value="_id"
                        @input="handleEmployeeInput"
                        dense
                      ></v-select>
                    </v-col>
                  </v-list-item>

                  <v-list-item class="px-0">
                    <v-col class="pb-0">
                      <v-select
                        class="wfm-search-fields"
                        :items="branches"
                        hide-details
                        solo
                        flat
                        clearable
                        outlined
                        label="Select Branch"
                        placeholder="Select Branch"
                        v-model="selectedBranchName"
                        item-text="branchName"
                        item-value="_id"
                        @input="handleEmployeeInput"
                        dense
                      ></v-select>
                    </v-col>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-col class="pb-0">
                      <v-select
                        class="wfm-search-fields"
                        :items="filteredTeams"
                        hide-details
                        solo
                        flat
                        clearable
                        outlined
                        label="Select Team"
                        placeholder="Select Team"
                        v-model="selectedTeamName"
                        item-text="teamName"
                        item-value="_id"
                        :disabled="!selectedBranchName"
                        @input="handleEmployeeInput"
                        dense
                      ></v-select>
                    </v-col>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-col class="pb-0">
                      <v-select
                        class="wfm-search-fields"
                        :items="departments"
                        hide-details
                        solo
                        flat
                        clearable
                        outlined
                        label="Select Department"
                        placeholder="Select Department"
                        v-model="selectedDepartment"
                        item-text="departmentName"
                        item-value="_id"
                        @input="handleEmployeeInput"
                        dense
                      ></v-select>
                    </v-col>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-col class="pb-0">
                      <v-select
                        class="wfm-search-fields"
                        :items="filteredDesignations"
                        hide-details
                        solo
                        flat
                        clearable
                        outlined
                        label="Select Designation"
                        placeholder="Select Designation"
                        v-model="selectedDesignation"
                        item-text="designationName"
                        item-value="_id"
                        :disabled="!selectedDepartment"
                        @input="handleEmployeeInput"
                        dense
                      ></v-select>
                    </v-col>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-col class="pb-0">
                      <v-select
                        class="wfm-search-fields"
                        :items="status"
                        hide-details
                        solo
                        flat
                        outlined
                        label="Select Status"
                        placeholder="Select Status"
                        v-model="selectedStatus"
                        item-text="role"
                        item-value="_id"
                        @input="handleEmployeeInput"
                        dense
                      ></v-select>
                    </v-col>
                  </v-list-item>
                </v-list>
              </v-card>
            </FilterPopOver>
            <v-menu offset-y class="w-16 ml-4">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <!-- Parent: Assign -->
                <v-menu open-on-hover offset-x :close-on-content-click="false" left>
                  <!-- <template v-slot:activator="{ on, attrs }">
                    <v-list-item
                      v-on="on"
                      v-bind="attrs"
                      :class="{ highlighted: hoveredParent === 'Assign' }"
                      @mouseover="hoveredParent = 'Assign'"
                      @mouseleave="hoveredParent = null"
                    >
                      <v-icon class="mr-2" :class="{ highlighted: hoveredParent === 'Assign' }"
                        >mdi-menu-left</v-icon
                      >
                      <v-list-item-title>Assign</v-list-item-title>
                    </v-list-item>
                  </template> -->
                  <v-list>
                    <v-list-item
                      @click="handleShowDialog('Teams')"
                      v-show="isFeatureVisible('ASSIGN_TEAM') && isAnyTeamSettingAllowed"
                    >
                      <v-list-item-title>Teams</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="handleShowDialog('Branches')"
                      v-show="isFeatureVisible('ASSIGN_BRANCH') && isAnyBranchSettingAllowed"
                    >
                      <v-list-item-title>Branch</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="handleShowDialog('SalaryTemplate')"
                      v-show="
                        isFeatureVisible('ASSIGN_SALARY_TEMPLATE') && isAnySalarySettingAllowed
                      "
                    >
                      <v-list-item-title>Salary Template</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- Parent: Export -->
                <v-menu open-on-hover offset-x :close-on-content-click="false" left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item
                      v-on="on"
                      v-bind="attrs"
                      :class="{ highlighted: hoveredParent === 'Export' }"
                      @mouseover="hoveredParent = 'Export'"
                      @mouseleave="hoveredParent = null"
                    >
                      <v-icon class="mr-2" :class="{ highlighted: hoveredParent === 'Export' }"
                        >mdi-menu-left</v-icon
                      >
                      <v-list-item-title>Export</v-list-item-title>
                    </v-list-item>
                  </template>
                  <v-list>
                    <v-list-item @click="fetchAndDownloadInactive('xlsx')">
                      <v-list-item-title>Non-Engaged Employees</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportAllEmployees">
                      <v-list-item-title>All Employees</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- Parent: Employee -->
                <v-menu open-on-hover offset-x :close-on-content-click="false" left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item
                      v-on="on"
                      v-bind="attrs"
                      :class="{ highlighted: hoveredParent === 'Employee' }"
                      @mouseover="hoveredParent = 'Employee'"
                      @mouseleave="hoveredParent = null"
                    >
                      <v-icon class="mr-2" :class="{ highlighted: hoveredParent === 'Employee' }"
                        >mdi-menu-left</v-icon
                      >
                      <v-list-item-title>Employees</v-list-item-title>
                    </v-list-item>
                  </template>
                  <v-list>
                    <v-list-item
                      :loading="loadingImport"
                      :disabled="loadingImport"
                      @click="importEmployees"
                      v-show="canWrite"
                    >
                      <v-list-item-title>Refresh List</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="openMap"
                      v-show="isFeatureVisible('EMPLOYEE_LIVE_TRACKING')"
                    >
                      <v-list-item-title>Live Location</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list>
            </v-menu>
          </template>

          <!-- Branches tab actions -->
          <template v-if="activeTab === 'branches'">
            <v-btn
              color="primary"
              @click="handleAddBranch"
              v-iam-disabled="'organization.branches.create'"
              class="font-medium"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <!-- Department & Designation tab actions -->
          <template v-if="activeTab === 'departmentdesignation'">
            <v-btn
              color="primary"
              @click="handleAddDepartment"
              v-iam-disabled="'organization.departments.create'"
              class="font-medium"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <!-- Salary template tab actions -->
          <template v-if="activeTab === 'Salarytemplate'">
            <v-btn
              color="primary"
              v-iam-disabled="'organization.salary_template.create'"
              @click="handleAddSalaryTemplate"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <!-- Leave management tab actions -->
          <template v-if="activeTab === 'leave'">
            <v-btn
              color="primary"
              v-iam-disabled="'organization.leave.update'"
              @click="handleAddLeavePlan"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <!-- Holiday management tab actions -->
          <template v-if="activeTab === 'holiday'">
            <v-btn
              color="primary"
              v-iam-disabled="'organization.holiday.create'"
              @click="handleAddHolidayPlan"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
        </div>
      </template>

      <!-- Tab Component Content -->
      <template v-for="tab in visibleTabs" v-slot:[tab.key]="">
        <div v-if="!isLoad" :key="tab.key">
          <v-main style="padding: 0px" class="">
            <component
              :is="tab.component"
              :key="tab.key"
              :roles="roles"
              :branches="branches"
              :teams="teams"
              :departments="departments"
              :designations="designations"
              :viewOrgTree="viewOrgTree"
              v-bind="getComponentProps(tab)"
              :ref="tab.key"
            />
          </v-main>
        </div>
        <div v-else class="loading-container" :key="`loading-${tab.key}`">
          <v-progress-circular
            :color="$vuetify.theme.currentTheme.primary"
            indeterminate
            :size="50"
            :width="5"
          ></v-progress-circular>
          <div class="mt-2"><span>Please Wait...</span></div>
        </div>
      </template>
    </ActitiveTabcomponent>
  </div>
</template>

<script>
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import { TAB_ITEMS } from '@/utils/workforce/constants'
import EmployeesPage from '@/pages/Workforce/EmployeesPage.vue'
import Roles from '@/components/Workforce/Settings/Roles.vue'
import TreeNode from '@/components/Workforce/EmployeeManagement/TreeNode.vue'
import BranchTeam from '@/components/Workforce/Settings/OrgConfigComponents/BranchTeam.vue'
import DepartmentDesignation from '@/components/Workforce/Settings/OrgConfigComponents/DepartmentDesignation.vue'
import SalaryTemplate from '@/components/Workforce/Settings/OrgConfigComponents/SalaryTemplateConfig/index.vue'
import LeaveManagement from '@/components/Workforce/Settings/OrgConfigComponents/LeaveManagement.vue'
import HolidayManagement from '@/components/Workforce/Settings/OrgConfigComponents/HolidayManagement.vue'
import FilterPopOver from '@/components/FilterPopOver.vue'
import { hasPermission, debounce } from '@/utils/common'
import permissionData from '@/utils/permissions'
import { axiosUrl } from '@/utils/workforceApi'

export default {
  name: 'OrganizationHierarchy',
  components: {
    ActitiveTabcomponent,
    EmployeesPage,
    SalaryTemplate,
    LeaveManagement,
    HolidayManagement,
    Roles,
    TreeNode,
    BranchTeam,
    DepartmentDesignation,
    FilterPopOver
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      isLoad: false,
      employeeTab: 0,
      totalEmployees: 0,
      totalDepartments: 0,
      hierarchyLevels: 0,
      viewOrgTree: false,
      // Role tab data
      additionalPermissions: [],
      roleFilter: '',
      // Employee tab data

      teams: [],
      branches: [],
      roles: [],
      departments: [],
      designations: [],
      status: ['ACTIVE', 'INACTIVE', 'CLOSED'],
      selectedTeamName: null,
      selectedBranchName: null,
      selectedRoleFilter: null,
      selectedDepartment: null,
      selectedDesignation: null,
      selectedStatus: 'ACTIVE',
      hoveredParent: null,
      loadingImport: false
    }
  },
  computed: {
    tabItems() {
      return TAB_ITEMS.ORGANIZATION.map((tab) => ({
        ...tab,
        label: tab.name,
        icon: tab.icon || 'mdi-account-group',
        visibility: true,
        component: this.getTabComponent(tab.key),
        permissionKey:
          tab.key === 'employees'
            ? 'organization.employees.read'
            : tab.key === 'role'
            ? 'organization.roles.read'
            : tab.key === 'branches'
            ? 'organization.branches.read'
            : tab.key === 'departmentdesignation'
            ? 'organization.departments.read'
            : tab.key === 'team'
            ? 'organization.teams.read'
            : tab.key === 'Salarytemplate'
            ? 'organization.salary_template.read'
            : tab.key === 'leave'
            ? 'organization.leave.read'
            : tab.key === 'holiday'
            ? 'organization.holiday.read'
            : null
      }))
    },
    visibleTabs() {
      return this.tabItems.filter((tab) => tab.visibility)
    },
    activeTab() {
      return this.$route.query.activeTab || this.defaultTabKey
    },
    defaultTabKey() {
      return this.visibleTabs.length > 0 ? this.visibleTabs[0].key : 'employees'
    },
    canWrite() {
      return hasPermission(this.userData, permissionData.userWrite)
    },
    selectedCount() {
      let count = 0

      // Count selected filters
      if (this.selectedTeamName) count++
      if (this.selectedBranchName) count++
      if (this.selectedRoleFilter) count++
      if (this.selectedDepartment) count++
      if (this.selectedDesignation) count++
      if (this.selectedStatus) count++

      return count
    },
    filteredTeams() {
      if (!this.selectedBranchName) {
        return []
      }

      const branchTeams = this.teams.filter((team) => team.branch === this.selectedBranchName)

      return branchTeams
    },
    filteredDesignations() {
      if (!this.selectedDepartment) {
        return []
      }
      const branchTeams = this.designations.filter(
        (el) => el.department?._id === this.selectedDepartment
      )

      return branchTeams
    }
  },
  methods: {
    tabVisible(key) {
      const visibilityMap = {
        employees: true,
        role: true,
        branches: true,
        departmentdesignation: true,
        team: true,
        Salarytemplate: true,
        leave: true,
        holiday: true
      }
      return visibilityMap[key] || false
    },
    getTabComponent(key) {
      const componentMap = {
        employees: 'EmployeesPage',
        role: 'Roles',
        branches: 'BranchTeam',
        departmentdesignation: 'DepartmentDesignation',
        team: 'BranchTeam',
        Salarytemplate: 'SalaryTemplate',
        leave: 'LeaveManagement',
        holiday: 'HolidayManagement'
      }
      return componentMap[key]
    },
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }
    },
    handleAddRole() {
      // Call the addRole method from the Roles component
      if (this.$refs.role && this.$refs.role[0]) {
        this.$refs.role[0].openForm()
      }
    },
    handleRoleFilterInput: debounce(function () {
      // Call the handleInput method from the Roles component
      if (this.$refs.role && this.$refs.role[0]) {
        this.$refs.role[0].filterRole = this.roleFilter
        this.$refs.role[0].handleInput()
      }
    }, 500),
    handleAddBranch() {
      if (this.$refs.branches && this.$refs.branches[0]) {
        this.$refs.branches[0].showBranchModal = true
      }
    },
    handleAddDepartment() {
      if (this.$refs.departmentdesignation && this.$refs.departmentdesignation[0]) {
        this.$refs.departmentdesignation[0].showDepartmentModal = true
      }
    },
    handleAddEmployee() {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].openAddEmployeeDialog()
      }
    },
    handleOrgTree() {
      this.viewOrgTree = !this.viewOrgTree
    },
    // Employee tab methods
    handleEmployeeInput() {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        const empComponent = this.$refs.employees[0]
        empComponent.selectedTeamName = this.selectedTeamName
        empComponent.selectedBranchName = this.selectedBranchName
        empComponent.selectedRoleFilter = this.selectedRoleFilter
        empComponent.selectedDepartment = this.selectedDepartment
        empComponent.selectedDesignation = this.selectedDesignation
        empComponent.selectedStatus = this.selectedStatus
        empComponent.handleInput()
      }
    },
    async fetchEmployeesData() {
      try {
        // Fetch teams
        const teamsResponse = await this.$axios.get(axiosUrl.teams.getTeams)
        this.teams = teamsResponse.data.teams || []

        // Fetch branches
        const branchesResponse = await this.$axios.get(axiosUrl.branches.getBranches)
        this.branches = branchesResponse.data.branches || []

        // Fetch roles
        const rolesResponse = await this.$axios.get(axiosUrl.role.fetchRole)
        this.roles = rolesResponse.data.role || []

        // Fetch departments
        const departmentsResponse = await this.$axios.get(axiosUrl.departments.getDepartments)
        this.departments = departmentsResponse.data.departments || []

        // Fetch designations
        const designationsResponse = await this.$axios.get(axiosUrl.designations.getDesignations)
        this.designations = designationsResponse.data.designations || []
      } catch (error) {
        console.error('Error fetching employees data:', error)
      }
    },
    // Employee menu methods
    handleShowDialog(type) {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].handleShowDialog(type)
      }
    },
    fetchAndDownloadInactive(format) {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].fetchAndDownloadInactive(format)
      }
    },
    exportAllEmployees() {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].exportAllEmployees()
      }
    },
    importEmployees() {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].importEmployees()
      }
    },
    onboardNewEmployees() {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].onboardNewEmployees()
      }
    },
    openMap() {
      // Delegate to EmployeesPage component
      if (this.$refs.employees && this.$refs.employees[0]) {
        this.$refs.employees[0].openMap()
      }
    },
    isFeatureVisible(feature) {
      // Simple feature visibility check - can be enhanced based on your needs
      return true
    },
    isAnyTeamSettingAllowed() {
      return true
    },
    isAnyBranchSettingAllowed() {
      return true
    },
    isAnySalarySettingAllowed() {
      return true
    },
    getComponentProps(tab) {
      const propsMap = {
        employees: {},
        role: {},
        branches: {
          mode: 'branches'
        },
        departmentdesignation: {},
        team: {
          mode: 'team'
        }
        // organizationhierarchy: {}
      }
      return propsMap[tab.key] || {}
    },
    handleAddSalaryTemplate() {
      // Delegate to SalaryTemplate component
      if (this.$refs.Salarytemplate && this.$refs.Salarytemplate[0]) {
        this.$refs.Salarytemplate[0].openCreateTemplate()
      }
    },
    handleAddLeavePlan() {
      // Delegate to LeaveManagement component
      if (this.$refs.leave && this.$refs.leave[0]) {
        this.$refs.leave[0].openCreateLeavePlan()
      }
    },
    handleAddHolidayPlan() {
      // Delegate to HolidayManagement component
      if (this.$refs.holiday && this.$refs.holiday[0]) {
        this.$refs.holiday[0].openCreateHolidayPlan()
      }
    }
  },
  watch: {
    activeTab(newTab) {
      const tabIndex = this.visibleTabs.findIndex((tab) => tab.key === newTab)
      this.employeeTab = tabIndex !== -1 ? tabIndex : 0
    }
  },
  mounted() {
    if (!this.$route.query.activeTab && this.defaultTabKey) {
      this.$router.replace({
        query: { ...this.$route.query, activeTab: this.defaultTabKey }
      })
    }
    const activeTabIndex = this.visibleTabs.findIndex((tab) => tab.key === this.activeTab)
    this.employeeTab = activeTabIndex !== -1 ? activeTabIndex : 0
    this.$nextTick(() => {
      this.isLoad = false
    })

    this.fetchEmployeesData()
  }
}
</script>

<style scoped>
.wfm-search-fields.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px !important;
}

.chip-width {
  width: 65%;
  overflow: hidden;
}

.chip-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-all-item {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #ffffff;
}

.highlighted {
  background: #21427d;
  color: white !important;
}

.filter-column {
  width: 300px;
}
</style>
